import get from "lodash/get";

import { Media } from "types";

export default (media: any): Media => ({
  title: get(media, "fields.title", ""),
  description: get(media, "fields.description", ""),
  url: get(media, "fields.file.url", "")
});
